export default "348893cc608ab25c.svg"